module.exports = __webpack_public_path__ + "static/media/HCMM271.06df8a87.jpg";